/**
 * Top Audio Bar — Real-time mic level visualization
 * Mirrored bars from center, ported from ADA V2
 */
import React, { useEffect, useRef } from 'react';

export default function TopAudioBar({ audioData = [] }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    const w = canvas.width = 300;
    const h = canvas.height = 30;

    const barWidth = 3;
    const gap = 2;
    const totalBars = Math.floor(w / (barWidth + gap));
    const center = w / 2;

    ctx.clearRect(0, 0, w, h);

    for (let i = 0; i < totalBars / 2; i++) {
      const value = audioData[i % audioData.length] || 0;
      const percent = value / 255;
      const barHeight = Math.max(2, percent * h);

      ctx.fillStyle = `rgba(0, 215, 255, ${0.15 + percent * 0.85})`;

      // Right side
      ctx.fillRect(center + i * (barWidth + gap), (h - barHeight) / 2, barWidth, barHeight);
      // Left side (mirrored)
      ctx.fillRect(center - (i + 1) * (barWidth + gap), (h - barHeight) / 2, barWidth, barHeight);
    }
  }, [audioData]);

  return (
    <canvas
      ref={canvasRef}
      style={{ width: '300px', height: '30px', opacity: 0.7 }}
      data-testid="top-audio-bar"
    />
  );
}
